<div class="col-md-6 mx-auto">
    <h1 class="text-center" style="padding-top: 200px; font-size: 50px;">404 page not found</h1>
</div>
